import React from "react";

import { LockPasswordIcon, UserIcon } from "./assets";
import { IBasicInput } from "./types";

export const typeToIconMap: Record<
  NonNullable<IBasicInput["iconType"]>,
  () => ReturnType<React.FC>
> = {
  password: () => <LockPasswordIcon />,
  user: () => <UserIcon />,
};
